import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { select, pointer } from 'd3';

const CoordinatesContext = createContext();
export const useMouseCoordinates = () => useContext(CoordinatesContext);

export const MouseCoordinatesWrapper = ({
  svgRef,
  children,
  displayContextMenu,
  tradePlanId,
}) => {
  const [coordinates, setCoordinates] = useState([0, 0]);
  const [showCrossHairs, setShowCrossHairs] = useState(false);

  useEffect(() => {
    select(svgRef.current)
      .on('mouseenter', () => {
        setShowCrossHairs(true);
      })
      .on('mousemove', (event) => {
        const coordinates = pointer(event);
        setCoordinates(coordinates);
      })
      .on('mouseleave', () => {
        setShowCrossHairs(false);
      })
      .on('contextmenu', (event) => {
        if (tradePlanId !== 'none') {
          const coordinates = pointer(event);
          displayContextMenu(event, coordinates[1]);
        }
      });
  }, []);

  return (
    <CoordinatesContext.Provider value={{ coordinates, showCrossHairs }}>
      {children}
    </CoordinatesContext.Provider>
  );
};

MouseCoordinatesWrapper.propTypes = {
  children: PropTypes.any,
  svgRef: PropTypes.shape({
    current: PropTypes.any,
  }),
  displayContextMenu: PropTypes.func,
  tradePlanId: PropTypes.any,
};
